import hbscan from "../../api/hbscan";
import IUserNotificationDetail from "../../models/userNotificationDetail";
import Auth from "../auth/AuthService";

class UserNotificationService {
    GetUserNotificationsByUserId = async (userId: number) => {
        const URL = `/api/hbscan/UserNotification/GetUserNotificationsByUserId`;

        return (
            await hbscan.get<IUserNotificationDetail[]>(URL, {
                headers: { Authorization: Auth.guid },
                params: { userId },
            })
        ).data;
    };

    GetUserNotificationsByLocalId = async (localId: number) => {
        const URL = `/api/hbscan/UserNotification/GetUserNotificationsByLocalId`;

        return (
            await hbscan.get<IUserNotificationDetail[]>(URL, {
                headers: { Authorization: Auth.guid },
                params: { localId },
            })
        ).data;
    };
}

const userNotificationService = new UserNotificationService();

export default userNotificationService;
